import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useHasHover from "common/helpers/useHasHover";

import type { ReactNode } from "react";

interface TooltipNavItemProps {
  isExpanded: boolean;
  component: ReactNode;
  label: string;
}

export default function TooltipNavItem({
  isExpanded,
  component,
  label,
}: TooltipNavItemProps) {
  const hasHover = useHasHover();

  if (hasHover) {
    return (
      <Tooltip disabled={isExpanded}>
        <TooltipTrigger asChild>{component}</TooltipTrigger>
        <TooltipContent
          side="right"
          sideOffset={8}
          className="pointer-events-none"
        >
          {label}
        </TooltipContent>
      </Tooltip>
    );
  }

  return component;
}
